import React from 'react';
import PropTypes from 'prop-types';
import { Button, Box, Typography } from '@mui/material';
import { useUserContext } from 'UserProvider';

const IframeComponent = ({ session, mode, onBack }) => {
  const courseIDSelected =
    localStorage.getItem('courseIdselected') &&
    localStorage.getItem('courseIdselected') !== 'undefined'
      ? localStorage.getItem('courseIdselected')
      : sessionStorage.getItem('activityInstance');
  const { userContext } = useUserContext();

  const baseUrl = `${process.env.REACT_APP_MOODLE_DEVELOPMENT_URL}/mod/kb/coursereport_kbws.php`;
  const token = process.env.REACT_APP_MOODLE_Token;
  const userId = userContext?.userData?.id || localStorage.getItem('userid');

  // Construct URL based on the mode
  const iframeUrl = `${baseUrl}?id=${courseIDSelected}&mode=${mode}&token=${token}&s=${userId}`;
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        padding: '20px',
        backgroundColor: '#f9f9f9'
      }}>
      {/* Back Button */}
      <Button
        variant="contained"
        color="primary"
        onClick={onBack}
        sx={{
          alignSelf: 'flex-start',
          marginBottom: '20px',
          backgroundColor: 'rgb(225, 230, 237)',
          '&:hover': { backgroundColor: 'rgb(180, 185, 191)' }
        }}>
        Back
      </Button>

      {/* Dynamic Header */}
      <Typography
        variant="h6"
        sx={{
          marginBottom: '10px',
          color: '#333',
          textAlign: 'center'
        }}>
        {`Session: ${session} - Report: ${mode.charAt(0).toUpperCase() + mode.slice(1)}`}
      </Typography>

      {/* Iframe */}
      <iframe
        src={iframeUrl}
        title={`${mode} report`}
        style={{
          width: '100%',
          height: '80%',
          border: '1px solid #ccc',
          borderRadius: '10px'
        }}></iframe>
    </Box>
  );
};

IframeComponent.propTypes = {
  mode: PropTypes.string.isRequired, // Mode for the iframe
  session: PropTypes.string.isRequired, // Session name
  onBack: PropTypes.func.isRequired // Callback for the back button
};

export default IframeComponent;
